<template>
  <div>
    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table
      v-if="winStreaks !== null && winStreaks.length > 0"
      class="table text-nowrap"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Win streak</th>
          <th scope="col">Amount of wins in a sequence</th>
        </tr>
      </thead>
      <tr
        v-for="metric in winStreaks"
        :key="metric.id"
      >
        <td>{{metric.id}}</td>
        <td>
          <win-streak-link
            :winStreakId="metric.win_streak_id"
            lable="win streak"
          />
        </td>
        <td>{{metric.value}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';
import WinStreakLink from './WinStreakLink.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'PlayerWinStreaks',

  components: {
    LoadingIndicator,
    WinStreakLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      /** @type {?Object[]} */
      winStreaks: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(this.isLoadedNormal && this.winStreaks !== null && this.winStreaks.length === 0) {
        return 'This player has no win streak metrics.';
      }
      return null;
    },
  },

  created() {
    this.loadWinStreaks();
  },

  methods: {
    loadWinStreaks() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/player/${this.playerId}/win_streaks`;
      HTTP.get(url)
      .then(response => {
        this.winStreaks = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>
